import Main from './Main.svelte';
const svelteApplication = new Main({ target: document.body });
export default svelteApplication;
